var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "nav-bar bg-white"
  }, [_c('div', {
    staticClass: "w-1200px h-80px mx-auto flex-btw"
  }, [_c('div', {
    staticClass: "bg-white"
  }, [_c('img', {
    staticClass: "w-234px h-36px cursor-pointer",
    attrs: {
      "src": require("@/assets/images/common/51hdc.png"),
      "alt": ""
    },
    on: {
      "click": _vm.$utils.toHome
    }
  })]), _vm.showOperation ? _c('div', {
    staticClass: "flex-btw text-20px"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/common/603194.png"),
      "width": "212",
      "height": "32",
      "alt": ""
    }
  }), _vm.$store.state.isLogin ? [_c('el-dropdown', {
    attrs: {
      "placement": "bottom-start"
    },
    on: {
      "command": _vm.handleRouterTo
    }
  }, [_c('div', {
    staticClass: "el-dropdown-link !text-primary leading-24px"
  }, [_c('i', {
    staticClass: "el-icon-arrow-down el-icon--right mr-6px cursor-pointer"
  }), _c('span', {
    staticClass: "text-20px cursor-pointer"
  }, [_vm._v(_vm._s(_vm.activatedLabel))])]), _c('el-dropdown-menu', {
    staticClass: "customNavDrop",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l(_vm.dropList, function ({
    value,
    label
  }, i) {
    return _c('el-dropdown-item', {
      key: i,
      attrs: {
        "divided": i != 0,
        "command": value
      }
    }, [_c('span', [_vm._v(_vm._s(label))])]);
  }), 1)], 1), _c('div', {
    staticClass: "w-1px h-18px bg-[#000000] mx-16px"
  }), _c('div', {
    staticClass: "text-20px cursor-pointer",
    on: {
      "click": _vm.handleLogout
    }
  }, [_vm._v(" 退出 ")])] : [_c('div', {
    staticClass: "text-20px text-white leading-48px bg-[#D7000F] rounded-13px text-center px-18px cursor-pointer",
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v(" 登录/注册 ")])]], 2) : _vm._e()])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "hotline"
  }, [_c('div', {
    staticClass: "hotline-info"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": require("@/assets/images/common/iphone.png"),
      "width": "24",
      "height": "24",
      "alt": ""
    }
  }), _vm._v(" 租赁热线：40000-33160 ")]), _c('p', [_c('a', {
    staticClass: "link-ep",
    attrs: {
      "href": "https://www.ep-zl.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/common/ep.png"),
      "width": "24",
      "height": "24",
      "alt": ""
    }
  }), _c('span', [_vm._v("中力")])])])])]);
}];
export { render, staticRenderFns };